import { inject, Injectable } from '@angular/core';
import { BehaviorSubject, map, Observable, shareReplay, switchMap } from 'rxjs';
import { PlatformsApiService } from './platforms-api.service';
import { BotPlatform } from './platforms.abstraction';

@Injectable({
    providedIn: 'root',
})
export class PlatformsService {
    #platformsApiService = inject(PlatformsApiService);

    #update$ = new BehaviorSubject<void>(void 0);

    isLoading$ = this.#platformsApiService.isLoading$;

    platformsRes$ = this.#update$.pipe(
        switchMap(() => this.#platformsApiService.getPlatforms()),
        shareReplay(1),
    );

    platforms$: Observable<BotPlatform[]> = this.platformsRes$.pipe(map(res => res.items));

    refresh(): void {
        this.#update$.next();
    }
}
